var _customDomainsData = [
  {
    host: "CustomDA1.entertainment.com",
    logo: "//cdn.shopify.com/s/files/1/1788/2177/t/6/assets/mc_donalds_logo-min.jpg?11866714847980438152",
    message: "CustomDA1 - Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
  },
  {
    host: "CustomDA2.entertainment.com",
    logo: "//cdn.shopify.com/s/files/1/1788/2177/products/2_luchos_mer39052347_logo.jpg?11866714847980438152",
    message: "CustomDA2 - Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
  },
  {
    host: "CustomDA3.entertainment.com",
    logo: "//cdn.shopify.com/s/files/1/1788/2177/t/6/assets/checkers_logo-min.jpg?11866714847980438152",
    message: "CustomDA3 - Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
  }
];

$(function() {
  $(".custom-site-logo").attr("src", $(".site-logo").attr("src"));

  $.each($.grep(_customDomainsData, function(value, index){
    return value.host.toLocaleLowerCase() == window.location.hostname.toLocaleLowerCase();
  }), function(index, value) {
    window.sessionStorage.setItem("is_digital_card_reg", "1");
    
    $(".digital-code-card-text").text("Digital Card");
    $(".custom-header-logo").attr("src", value.logo).show();
    $(".custom-message-text").text(value.message).show();
    $(".custom-logo-divider").show();
  });  
});

function customRegCodeModalOpenClose() {
  window.setTimeout(function() {
    $(".input-group").each(function(){$(this).width("auto");var w=Math.floor($(this).width());$(this).width(w+2);});
  }, 200);
}
